



































import Vue from 'vue'
import BaseButton from '../atoms/BaseButton.vue';

export default Vue.extend({
  components: {
    BaseButton
  },
  props: {
    subject: {
      type: Object,
      required: true
    }
  }
})
